import { isRecord, Record } from 'immutable';

/**
 * Описывает тип полученных данных
 * data сами данные
 * isLoading флаг загрузки
 * время последней загрузки если 0 загрузки не было
 * error описание ошибки
 */
export type FetchedDataObj<T> = {
  data: T | null;
  past: {
    data: T[];
    LTU: number;
  };
  isLoading: boolean;
  LTU: number;
  error: {
    isError: boolean;
    message: string;
    code?: number;
    mnemonic?: string;
    description?: string;
    fields?: string[];
    creatives?: { xxhash: string; title: string; campaign_xxhash: string }[];
  };
};

export type FetchedData<T> = Record<FetchedDataObj<T>>;

/**
 * генерирует обьект FetchedData с данными по умолчанию
 */
export function genFetchedData<T>(data: T | null): FetchedData<T> {
  const initData: FetchedDataObj<T> = {
    data,
    past: {
      data: [],
      LTU: 0,
    },
    isLoading: false,
    LTU: 0,
    error: {
      isError: false,
      message: '',
      code: 0,
      fields: [],
    },
  };
  const FetchedDataF: Record.Factory<FetchedDataObj<T>> = Record(initData);
  return new FetchedDataF();
}

/**
 * функция извлекает данные из имктабельного объекта
 * */
export const extractGenFetchData = <T>(
  param: FetchedData<T>,
): FetchedDataObj<T> => {
  if (param && isRecord(param)) {
    return {
      past: param.get('past'),
      data: param.get('data'),
      isLoading: param.get('isLoading'),
      error: param.get('error'),
      LTU: param.get('LTU'),
    };
  }
  return {
    past: {
      data: [],
      LTU: 0,
    },
    data: null,
    isLoading: false,
    error: {
      isError: false,
      code: 0,
      fields: [],
      message: '',
    },
    LTU: 0,
  };
};
